import React from 'react'
import { Canvas } from '@react-three/fiber'

interface FinishingFXCanvasProps {
  children: React.ReactNode
}

const FinishingFXCanvas: React.FC<FinishingFXCanvasProps> = ({ children }) => {
  return (
    <Canvas
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
      camera={{ position: [0, 0, 1], fov: 50 }}
      dpr={[1, 1.5]}
      gl={{ alpha: true, antialias: false, powerPreference: 'high-performance' }}
      orthographic={false}
    >
      {children}
    </Canvas>
  )
}

export default FinishingFXCanvas
